import React, { Fragment } from 'react'
import {  InternationalNumber, } from '../../../../selectors/getType';
export default function SingleStore({store, index}) {
    const google = `https://maps.google.com/?q=:${store.streetAndNumber} ${store.city}  ${store.province}  ${store.zip}`;
  return (
    <Fragment>
        <div className={`store-${index}`}>
            <div className="storeTitle">
                <div className="store100"><p className="cic-heading-4 textLeft">{store.name} {store.city}</p></div> 
            </div>
            <div className="store-details">
                <div className="rt-loan-amount heightDir">
                    <div className="iconDiv">
                        <div className="cic-icon-primary spaceIcon noRepeat mm-icon-wrapper IconMapPin"></div>
                        <div className="spanDir">
                            <p><span className="cic-paragraph--medium">{store.streetAndNumber}, {store.city}, {store.province}</span> 
                            </p>
                        </div>
                    </div>
                </div>
                <div className="rt-loan-amount">
                    <div className="iconDiv">
                        <div className="cic-icon-primary spaceIcon noRepeat mm-icon-wrapper IconPhone"></div>
                        <div>
                            <a href={`tel:+${store.phone}`}>
                                <p><span className="cic-paragraph--medium">{InternationalNumber(store.phone)}</span></p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>   
            <div className="spaceLoans">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={google}
                    className="cic-btn cic-btn-secondary--dark"
                    aria-label={`Find a ${store.name} store near you`}
                > 
                    Get Directions 
                </a>
                <a href={`${store.website}`} rel="noopener noreferrer" className="cic-btn green-cic spaceTop">More Store Details </a>
            </div>
            <hr className="directions" />
        </div> 
    </Fragment>
  )
}
